/* herolift-cdn-bust 1787732800-buycols */
/* tl-hero-lead-width-20260901 */
(function () {
  try {
    var path = (location.pathname || '').toLowerCase();
    var onChefs =
      path === '/pages/shop-chefs-pan' ||
      path === '/nl/pages/shop-chefs-pan' ||
      path === '/pages/buy-chefs-pan' ||
      path === '/nl/pages/buy-chefs-pan' ||
      path === '/pages/chefs-pan' ||
      path === '/nl/pages/chefs-pan' ||
      path === '/pages/chefs-pan-now' ||
      path === '/nl/pages/chefs-pan-now' ||
      path === '/pages/get-chefs-pan' ||
      path === '/nl/pages/get-chefs-pan';
    if (!onChefs) return;
    if (window.__tlHeroVbDesk) return;
    window.__tlHeroVbDesk = 1;

    var VIDEO = 'https://cdn.shopify.com/videos/c/o/v/c29cf83cf80842bd85b7ea4d961493be.mp4';
    var POSTER =
      'https://cdn.shopify.com/s/files/1/1009/4254/5283/files/tl-hero-handen-pan-2528_39e3df5e-facb-4e8b-97e8-8301d0d8fc90.jpg?v=1786683535&width=2400';

    /* Kill stale page_cache overrides that force contain + beige letterboxing */
    var stale = document.getElementById('tl-pan-fullvis-override');
    if (stale) stale.remove();

    /* Always re-assert hero-lift CSS — includes desk/iPad two-column buy box */
    var style = document.getElementById('tl-hero-video-behind-override');
    if (!style) {
      style = document.createElement('style');
      style.id = 'tl-hero-video-behind-override';
      document.documentElement.appendChild(style);
    }
    style.setAttribute('data-tl-hero-lift', '20260814-truehires');
    style.textContent = [
      '[data-tgem-buy] .tgem-hero{position:relative!important;display:flex!important;flex-direction:column!important;align-items:flex-start!important;grid-template-columns:none!important;min-height:min(72vh,560px)!important;overflow:hidden!important;isolation:isolate!important;background:#1a1a1a!important;gap:0!important;max-width:none!important;margin:0!important;padding:0!important}',
      '[data-tgem-buy] .tgem-hero__media{position:absolute!important;inset:0!important;z-index:0!important;order:0!important;pointer-events:auto!important;cursor:pointer!important;background:#1a1a1a url("' + POSTER + '") center 40%/cover no-repeat!important;overflow:hidden!important;aspect-ratio:auto!important;max-height:none!important;min-height:0!important}',
      '[data-tgem-buy] .tgem-hero__media img,[data-tgem-buy] .tgem-hero__media video{width:100%!important;height:100%!important;min-height:0!important;max-height:none!important;object-fit:cover!important;object-position:center 40%!important;background:#1a1a1a!important;display:block!important;filter:none!important}',
      '[data-tgem-buy] .tgem-hero::after{content:""!important;position:absolute!important;inset:0!important;z-index:1!important;pointer-events:none!important;background:linear-gradient(180deg,rgba(0,0,0,.08) 0%,rgba(0,0,0,.14) 42%,rgba(0,0,0,.52) 78%,rgba(0,0,0,.68) 100%)!important}',
      '[data-tgem-buy] .tgem-hero__copy{position:relative!important;z-index:2!important;order:0!important;flex:1 1 auto!important;flex-shrink:0!important;align-self:stretch!important;box-sizing:border-box!important;width:min(42rem,88vw)!important;min-width:min(36rem,88vw)!important;max-width:min(42rem,88vw)!important;padding:36px 20px 40px!important;color:#fff!important}',
      '[data-tgem-buy] .tgem-hero__copy .tgem-lead{display:block!important;width:min(42rem,88vw)!important;min-width:min(20rem,88vw)!important;max-width:min(42rem,88vw)!important;white-space:normal!important;overflow-wrap:break-word!important;word-break:normal!important;writing-mode:horizontal-tb!important;columns:auto!important}',
      '[data-tgem-buy] .tgem-hero__copy .tgem-eyebrow,[data-tgem-buy] .tgem-hero__copy h1,[data-tgem-buy] .tgem-hero__copy .tgem-lead,[data-tgem-buy] .tgem-hero__copy .tgem-stake{color:#fff!important;text-shadow:0 1px 12px rgba(0,0,0,.45)}',
      '[data-tgem-buy] .tgem-hero__copy h1{font-size:clamp(26px,6.2vw,38px)!important;max-width:min(22ch,100%)!important;text-shadow:0 2px 18px rgba(0,0,0,.5)}',
      '[data-tgem-buy] .tgem-hero__cta{display:inline-flex!important;align-items:center!important;justify-content:center!important;margin-top:18px!important;min-height:48px!important;padding:14px 28px!important;border-radius:2px!important;background:#fff!important;color:#272727!important;border:1px solid #fff!important;font-size:13px!important;font-weight:600!important;letter-spacing:.08em!important;text-transform:uppercase!important;text-decoration:none!important;cursor:pointer!important;appearance:none!important;-webkit-appearance:none!important;font-family:inherit!important}',
      '[data-tgem-buy] .tgem-configure{padding:28px 20px 32px!important;max-width:640px!important;width:100%!important;box-sizing:border-box!important;background:#fcfaf6!important}',
      '@media (min-width:768px){[data-tgem-buy] .tgem-configure{max-width:980px!important;margin:0 auto!important;padding:36px 28px 48px!important;display:flex!important;flex-direction:column!important;grid-template-columns:none!important}[data-tgem-buy] .tgem-buycols{display:grid!important;grid-template-columns:minmax(260px,.95fr) minmax(300px,1.1fr)!important;column-gap:36px!important;align-items:start!important;width:100%!important}[data-tgem-buy] .tgem-buyright{display:flex!important;flex-direction:column!important;grid-column:2!important;grid-row:1!important;min-width:0!important;z-index:1!important}[data-tgem-buy] .tgem-buycols>.tgem-sizevis,[data-tgem-buy] .tgem-configure>.tgem-sizevis{grid-column:1!important;grid-row:1!important;width:100%!important;max-width:100%!important;margin:0!important;position:relative!important;top:auto!important;align-self:start!important;overflow:visible!important;z-index:0!important;padding:12px 8px 20px!important;background:#f3eee6!important;border-radius:12px!important;box-sizing:border-box!important}[data-tgem-buy] .tgem-buycols>.tgem-sizevis img,[data-tgem-buy] .tgem-configure>.tgem-sizevis img{display:block!important;width:100%!important;max-width:100%!important;max-height:min(420px,58vh)!important;height:auto!important;aspect-ratio:auto!important;margin:0 auto!important;object-fit:contain!important}[data-tgem-buy] .tgem-configure>.tgem-features{width:100%!important;grid-column:auto!important;grid-row:auto!important;position:relative!important;z-index:2!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;margin-top:28px!important}[data-tgem-buy] .tgem-configure>.tgem-ship{width:100%!important;grid-column:auto!important;grid-row:auto!important}.titanore-demo-strip .tds-track{display:grid!important;grid-auto-flow:unset!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;overflow:visible!important;gap:16px!important}.titanore-demo-strip .tds-card__media{aspect-ratio:3/4!important}}',
      '@media (min-width:900px){[data-tgem-buy] .tgem-hero{align-items:center!important;min-height:min(78vh,680px)!important}[data-tgem-buy] .tgem-hero::after{background:linear-gradient(90deg,rgba(0,0,0,.55) 0%,rgba(0,0,0,.28) 36%,rgba(0,0,0,.08) 62%,rgba(0,0,0,0) 100%),linear-gradient(180deg,rgba(0,0,0,.08) 0%,rgba(0,0,0,.04) 50%,rgba(0,0,0,.32) 100%)!important}[data-tgem-buy] .tgem-hero__media img,[data-tgem-buy] .tgem-hero__media video{object-position:center center!important}[data-tgem-buy] .tgem-hero__copy{width:min(42rem,88vw)!important;min-width:min(36rem,88vw)!important;max-width:min(42rem,88vw)!important;padding:56px 48px 56px max(40px,calc((100vw - 1500px)/2 + 20px))!important}[data-tgem-buy] .tgem-hero__copy h1{font-size:clamp(34px,3.6vw,48px)!important;max-width:18ch!important}[data-tgem-buy] .tgem-configure{max-width:1120px!important;margin:0 auto!important;padding:48px 40px 56px!important;display:flex!important;flex-direction:column!important;grid-template-columns:none!important}[data-tgem-buy] .tgem-buycols{column-gap:48px!important;grid-template-columns:minmax(320px,1fr) minmax(360px,1.05fr)!important}}',
      '@media (min-width:1200px){[data-tgem-buy] .tgem-configure{max-width:1180px!important;padding:56px 48px 64px!important;column-gap:56px!important}}',
      '@media (prefers-reduced-motion:reduce){[data-tgem-buy] .tgem-hero__media video{display:none!important}[data-tgem-buy] .tgem-hero__media{background:#1a1a1a url("' +
        POSTER +
        '") center 40%/cover no-repeat!important}}',
      '.titanore-demo-strip .tds-card__media{aspect-ratio:4/5!important;background:#1a1a1a!important;overflow:hidden!important}',
      '.titanore-demo-strip .tds-card__media img,.titanore-demo-strip .tds-card__media video{object-fit:cover!important;object-position:center!important;background:transparent!important;width:100%!important;height:100%!important;inset:0!important}'
    ].join('');
    /* Separate tag so later scripts cannot re-inject sticky via #tl-hero-video-behind-override */
    var noSticky = document.getElementById('tl-sizevis-nosticky');
    if (!noSticky) {
      noSticky = document.createElement('style');
      noSticky.id = 'tl-sizevis-nosticky';
      document.documentElement.appendChild(noSticky);
    }
    noSticky.textContent =
      '@media (min-width:768px){[data-tgem-buy] .tgem-configure{display:flex!important;flex-direction:column!important;grid-template-columns:none!important}[data-tgem-buy] .tgem-buycols{display:grid!important;grid-template-columns:minmax(260px,.95fr) minmax(300px,1.1fr)!important;align-items:start!important;width:100%!important}[data-tgem-buy] .tgem-buycols>.tgem-sizevis,[data-tgem-buy] .tgem-configure>.tgem-sizevis{position:relative!important;top:auto!important;grid-column:1!important;grid-row:1!important;overflow:visible!important;z-index:0!important}[data-tgem-buy] .tgem-configure>.tgem-features{position:relative!important;z-index:2!important;grid-column:auto!important;grid-row:auto!important;width:100%!important}}';
    var demoFix = document.getElementById('tl-media-cover-demo');
    if (!demoFix) {
      demoFix = document.createElement('style');
      demoFix.id = 'tl-media-cover-demo';
      demoFix.textContent =
        '.titanore-demo-strip .tds-card__media{aspect-ratio:4/5!important;background:#1a1a1a!important;overflow:hidden!important}' +
        '.titanore-demo-strip .tds-card__media img,.titanore-demo-strip .tds-card__media video{object-fit:cover!important;object-position:center!important;background:transparent!important;width:100%!important;height:100%!important}';
      document.documentElement.appendChild(demoFix);
    }
    /* Re-assert after deferred ATC scripts that may re-inject contain */
    function assertDemoCover() {
      var again = document.getElementById('tl-pan-fullvis-override');
      if (again) again.remove();
      var existing = document.getElementById('tl-media-cover-demo') || document.getElementById('tl-media-cover-override');
      if (!existing) {
        var s2 = document.createElement('style');
        s2.id = 'tl-media-cover-demo';
        s2.textContent =
          '.titanore-demo-strip .tds-card__media{aspect-ratio:4/5!important;background:#1a1a1a!important}' +
          '.titanore-demo-strip .tds-card__media img,.titanore-demo-strip .tds-card__media video{object-fit:cover!important;object-position:center!important;background:transparent!important}';
        document.documentElement.appendChild(s2);
      }
    }
    assertDemoCover();
    setTimeout(assertDemoCover, 100);
    setTimeout(assertDemoCover, 600);

    function lang() {
      return path.indexOf('/nl') === 0 ? 'nl' : 'en';
    }


    /* Desktop: sharp still (2528px) instead of soft AI video upscaled on retina */
    function ensureDeskStill() {
      var media = document.querySelector('[data-tgem-buy] .tgem-hero__media');
      if (!media) return;
      var wide = window.matchMedia && window.matchMedia('(min-width:900px)').matches;
      var still = media.querySelector('img[data-tl-hero-still]');
      var vid = media.querySelector('video');
      if (wide) {
        if (!still) {
          still = document.createElement('img');
          still.setAttribute('data-tl-hero-still', '1');
          still.alt = '';
          still.decoding = 'async';
          still.fetchPriority = 'high';
          still.src = POSTER;
          media.insertBefore(still, media.firstChild);
        } else {
          still.src = POSTER;
        }
        if (vid) {
          try { vid.pause(); } catch (e) {}
          vid.style.setProperty('display', 'none', 'important');
        }
        still.style.setProperty('display', 'block', 'important');
      } else {
        if (still) still.style.setProperty('display', 'none', 'important');
        if (vid) vid.style.removeProperty('display');
      }
    }

    function wrapBuycols() {
      var box = document.querySelector('[data-tgem-buy] .tgem-configure');
      if (!box || box.querySelector('.tgem-buycols')) return;
      var vis = box.querySelector('.tgem-sizevis');
      if (!vis) return;
      var cols = document.createElement('div');
      cols.className = 'tgem-buycols';
      var right = document.createElement('div');
      right.className = 'tgem-buyright';
      var keep = { 'tgem-features': 1, 'tgem-ship': 1, 'tgem-whybox': 1 };
      Array.prototype.slice.call(box.children).forEach(function (el) {
        if (el === vis) return;
        if (keep[el.classList && el.classList[0]]) return;
        if (el.classList.contains('tgem-features') || el.classList.contains('tgem-ship') || el.classList.contains('tgem-whybox')) return;
        right.appendChild(el);
      });
      cols.appendChild(vis);
      cols.appendChild(right);
      var feat = box.querySelector('.tgem-features');
      box.insertBefore(cols, feat || box.firstChild);
    }

    function applyHero() {
      wrapBuycols();
      var root = document.querySelector('[data-tgem-buy]');
      if (!root) return;
      var hero = root.querySelector('.tgem-hero');
      var media = root.querySelector('.tgem-hero__media');
      var copy = root.querySelector('.tgem-hero__copy');
      if (!hero || !media || !copy) return;

      var vid = media.querySelector('video');
      if (vid) {
        vid.setAttribute('poster', POSTER);
        vid.setAttribute('playsinline', '');
        vid.muted = true;
        vid.loop = true;
        var source = vid.querySelector('source');
        if (source && source.getAttribute('src') !== VIDEO) {
          source.setAttribute('src', VIDEO);
          try {
            vid.load();
          } catch (e) {}
        }
        var reduce =
          window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!reduce) {
          var p = vid.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          try {
            vid.pause();
          } catch (e2) {}
        }
      }

      if (!root.querySelector('.tgem-configure')) {
        var configure = document.createElement('div');
        configure.className = 'tgem-configure';
        configure.id = 'tgem-configure';
        var move = false;
        Array.prototype.slice.call(copy.children).forEach(function (el) {
          if (
            el.classList.contains('tgem-sizehead') ||
            el.classList.contains('tgem-sizes') ||
            el.classList.contains('tgem-sale') ||
            el.classList.contains('tgem-summary') ||
            el.classList.contains('tgem-cta') ||
            el.classList.contains('tgem-cta-sub') ||
            el.classList.contains('tgem-sets') ||
            el.classList.contains('tgem-trustgrid') ||
            el.classList.contains('tgem-features') ||
            el.classList.contains('tgem-whybox') ||
            el.classList.contains('tgem-ship') ||
            move
          ) {
            move = true;
            configure.appendChild(el);
          }
        });
        if (configure.childNodes.length) hero.insertAdjacentElement('afterend', configure);
      }

      var eyebrow = copy.querySelector('.tgem-eyebrow');
      if (eyebrow) {
        eyebrow.setAttribute('data-en', 'Titanoré Labs');
        eyebrow.setAttribute('data-nl', 'Titanoré Labs');
        eyebrow.textContent = 'Titanoré Labs';
      }
      var h1 = copy.querySelector('h1') || root.querySelector('h1');
      if (h1) {
        h1.setAttribute('data-en', 'No coating. Nothing to wear off.');
        h1.setAttribute('data-nl', 'Geen coating. Niets dat slijt.');
        h1.textContent =
          lang() === 'nl'
            ? 'Geen coating. Niets dat slijt.'
            : 'No coating. Nothing to wear off.';
      }
      /* Keep Liquid hero ATC. Old cache used to inject/remove "Kies je maat". */

      ensureDeskStill();
    }

    function clearOverlap() {
      var wide = window.matchMedia && window.matchMedia('(min-width:768px)').matches;
      var box = document.querySelector('[data-tgem-buy] .tgem-configure');
      if (!box) return;
      var vis = box.querySelector(':scope > .tgem-sizevis');
      var feat = box.querySelector(':scope > .tgem-features');
      var trust = box.querySelector(':scope > .tgem-trustgrid');
      if (feat) feat.style.marginTop = '';
      if (trust) trust.style.marginBottom = '';
      if (!wide || !vis || !feat) return;
      var vr = vis.getBoundingClientRect();
      var fr = feat.getBoundingClientRect();
      if (vr.bottom > fr.top + 2) {
        var extra = Math.ceil(vr.bottom - fr.top + 20);
        var cur = parseFloat(window.getComputedStyle(feat).marginTop) || 0;
        feat.style.setProperty('margin-top', cur + extra + 'px', 'important');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyHero);
    } else {
      applyHero();
    }
    if (!window.__tlHeroStillResize) {
      window.__tlHeroStillResize = 1;
      window.addEventListener('resize', function () { ensureDeskStill(); clearOverlap(); }, { passive: true });
    }
    setTimeout(applyHero, 200);
    setTimeout(applyHero, 800);
    setTimeout(clearOverlap, 250);
    setTimeout(clearOverlap, 900);
    setTimeout(clearOverlap, 1800);
  } catch (err) {}
})();
